import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faInstagram, faYoutube } from '@fortawesome/free-brands-svg-icons'
import { logAnalyticsEvent } from './firebase/config'

// Import styles but not fonts (fonts are handled in index.html)
// import './assets/fonts/index.js'

// Add the icons to the library
library.add(faInstagram, faYoutube)

const app = createApp(App)

app.use(router)
app.use(store)

// Register FontAwesomeIcon component globally
app.component('FontAwesomeIcon', FontAwesomeIcon)

// Track route changes for analytics
router.afterEach((to) => {
  // Log page_view events when route changes
  logAnalyticsEvent('page_view', {
    page_title: to.name || 'Unknown',
    page_path: to.path
  });
});

app.mount('#app')
